import Vue from 'vue'
import Vuex from 'vuex'
// import {getAdminInfo} from '@/api/getData'

Vue.use(Vuex)

const state = {
	adminInfo: {
		avatar: 'default.jpg'
	},
	leftMenu:[],
	CategoryId:"",
	limit:"",
	pageSize:"",
	RowId:"",
	fullLoading:false,
	iframeUrl:"",
	FontSize:"",
	isMobile:false,
	isScreenTitle:'',// 是否显示面包屑
    menuBread:[],//面包屑根目录（列表页或通用页面根据点击菜单返回的值，MyData相关页只保留第一级根目录）
    CategoryBread: [],//MyData相关页,当前模板所对应的分类层级
    CurrentTemplateName: "", //MyData相关页,当前模板的模板名称
    MyDataEventState: "",//通用于全部页面，当前按钮动作，有add,edit,copyLine,preview,auditTrail,auditTrailDetails,managementClient,ViewAll
}

const mutations = {
	saveAdminInfo(state, adminInfo){
		state.adminInfo = adminInfo;
	},
	iframeUrlFun(state,iframeUrl){
		state.iframeUrl = iframeUrl;
	},
	changeLeftMenu(state,leftMenu){
		if(state.leftMenu.length == leftMenu.length){
			// 更改数据维护文字时
			if(state.leftMenu[0].MenuList.length  == leftMenu[0].MenuList.length){
				for(var i=0;i<state.leftMenu[0].MenuList.length;i++){
					if(state.leftMenu[0].MenuList[i].MasterName!=leftMenu[0].MenuList[i].MasterName){
						state.leftMenu[0].MenuList = leftMenu[0].MenuList;
					}
				}
			} else{
				state.leftMenu[0].MenuList = leftMenu[0].MenuList;
			}
			// 更改权限时 2
			if(state.leftMenu.length >2){
				if(state.leftMenu[2].MenuList.length  == leftMenu[2].MenuList.length){
					for(var i=0;i<state.leftMenu[2].MenuList.length;i++){
						if(state.leftMenu[2].MenuList[i].MasterName!=leftMenu[2].MenuList[i].MasterName){
							state.leftMenu[2].MenuList = leftMenu[2].MenuList;
						}
					}
				} else{
					state.leftMenu[2].MenuList = leftMenu[2].MenuList;
				}
			}
		} else{
			state.leftMenu = leftMenu;
		}
	},
	changeCategoryIdFun(state,CategoryId){
		state.CategoryId = CategoryId;
	},
	limitFun(state,limit){
		state.limit = limit;
	},
	pageSizeFun(state,pageSize){
		state.pageSize = pageSize;
	},
	changeRowIdFun(state,RowId){
		state.RowId = RowId;
	},
	fullLoadingFun(state,fullLoading){
		state.fullLoading = fullLoading;
	},
	isScreenTitleFun(state,isScreenTitle){
        state.isScreenTitle = isScreenTitle;
	},
    menuBreadFun(state,menuBread){
        state.menuBread = menuBread;
    },
    CategoryBreadFun(state, CategoryBread) {
        state.CategoryBread = CategoryBread;
    },
    CurrentTemplateNameFun(state, CurrentTemplateName) {
        state.CurrentTemplateName = CurrentTemplateName;
    },
    MyDataEventStateFun(state, MyDataEventState){
        state.MyDataEventState = MyDataEventState
    }
}

const actions = {
	async getAdminData({commit}){
		try{
			if (res.status == 1) {
				commit('saveAdminInfo', res.data);
			}else{
				throw new Error(res)
			}
		}catch(err){
		}
	}
}
export default new Vuex.Store({
	state,
	actions,
	mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js